// extracted by mini-css-extract-plugin
export default {"main":"ContactUs_main__LdpYY","title":"ContactUs_title__ddUyI","contact-container":"ContactUs_contact-container__15sM5"};